/* eslint-disable import/prefer-default-export */
export const userConstants = {
  GET_USER_REQUEST: 'USERS_GET_USER_REQUEST',
  GET_USER_SUCCESS: 'USERS_GET_USER_SUCCESS',
  GET_USER_FAILURE: 'USERS_GET_USER_FAILURE',
  UNLOAD_USER: 'USERS_UNLOAD_USER',

  LOGIN_REFRESH_REQUEST: 'USERS_LOGIN_REFRESH_REQUEST',
  LOGIN_REFRESH_SUCCESS: 'USERS_LOGIN_REFRESH_SUCCESS',
  LOGIN_REFRESH_FAILURE: 'USERS_LOGIN_REFRESH_FAILURE',

  LOGIN_REQUEST: 'USERS_LOGIN_REQUEST',
  LOGIN_SUCCESS: 'USERS_LOGIN_SUCCESS',
  LOGIN_FAILURE: 'USERS_LOGIN_FAILURE',

  REQUEST_NEW_PASSWORD: 'USERS_REQUEST_NEW_PASSWORD',
  SUCCESS_NEW_PASSWORD: 'USERS_SUCCESS_NEW_PASSWORD',
  FAILURE_NEW_PASSWORD: 'USERS_FAILURE_NEW_PASSWORD',

  REQUEST_UPDATE_USER: 'USERS_REQUEST_UPDATE_USER',
  SUCCESS_UPDATE_USER: 'USERS_SUCCESS_UPDATE_USER',
  FAILURE_UPDATE_USER: 'USERS_FAILURE_UPDATE_USER',

  REQUEST_UPDATE_TEACHER: 'USERS_REQUEST_UPDATE_TEACHER',
  SUCCESS_UPDATE_TEACHER: 'USERS_SUCCESS_UPDATE_TEACHER',
  FAILURE_UPDATE_TEACHER: 'USERS_FAILURE_UPDATE_TEACHER',

  REQUEST_UPDATE_CUSTOMER: 'USERS_REQUEST_UPDATE_CUSTOMER',
  SUCCESS_UPDATE_CUSTOMER: 'USERS_SUCCESS_UPDATE_CUSTOMER',
  FAILURE_UPDATE_CUSTOMER: 'USERS_FAILURE_UPDATE_CUSTOMER',

  LOGOUT: 'USERS_LOGOUT',
};
